<template>
  <div :id="`${source}_custom_list_selector`">
    <div
      class="flex gap-2 w-full px-[14px]"
      :class="{
        'flex-row overflow-x-auto':
          orientation === customSelectorDirections.HORIZONTAL,
        'flex-col overflow-y-auto':
          orientation === customSelectorDirections.VERTICAL,
      }"
    >
      <div
        v-for="(value, key) in list"
        :key="key"
        class="flex flex-row gap-[10px] items-center cursor-pointer list_selector_block flex-shrink-0"
        :class="{
          selected: selectedItems.includes(parseInt(key)),
        }"
        @click="toggleSelection(parseInt(key))"
      >
        <a-checkbox
          :checked="selectedItems.includes(parseInt(key))"
          @click.stop="toggleSelection(parseInt(key))"
          readonly
        />

        <div class="flex flex-row gap-[6px] items-center">
          <ProfileIcon :data="typeof value === 'object' ? value : { name: value }" :size="20" :font="9" />

          <span
            class="text-[11px] font-normal primary_color whitespace-nowrap"
            >{{ typeof value === 'object' ? value.name : value }}</span
          >
        </div>
      </div>
    </div>
  </div>
</template>

<script setup>
import { ref, watch } from "vue";
import { customSelectorDirections } from "@/src/constants/customComponentConstants.js";
import ProfileIcon from "@/src/components/ProfileIcon.vue";

const props = defineProps({
  source: { type: String, required: true },
  list: { type: Object, required: true },
  modelValue: { type: Array, default: () => [] },
  orientation: { type: String, default: customSelectorDirections.HORIZONTAL },
});

const emit = defineEmits(["update:modelValue"]);

const selectedItems = ref([...(props.modelValue || [])]);

watch(
  () => props.modelValue,
  (newVal) => {
    selectedItems.value = [...(newVal || [])];
  },
  { immediate: true },
);

const toggleSelection = (key) => {
  try {
    const index = selectedItems.value.indexOf(key);
    if (index > -1) {
      selectedItems.value.splice(index, 1);
    } else {
      const allKeys = Object.keys(props.list)
        .map((k) => parseInt(k))
        .sort((a, b) => a - b);
      const insertIndex = selectedItems.value.findIndex((item) => {
        const itemPosition = allKeys.indexOf(item);
        const keyPosition = allKeys.indexOf(key);
        return itemPosition > keyPosition;
      });

      if (insertIndex === -1) {
        selectedItems.value.push(key);
      } else {
        selectedItems.value.splice(insertIndex, 0, key);
      }
    }

    emit("update:modelValue", [...selectedItems.value]);
  } catch (error) {
    console.error("An error occurred while toggling selection: ", error);
  }
};
</script>

<style scoped>
.list_selector_block {
  padding: 4px 8px;
  align-items: center;
  border-radius: 8px;
  border: 1px solid var(--white-opacity-8);
  background-color: var(--white-opacity-6);
  transition:
    border 0.4s ease-in-out,
    background-color 0.4s ease-in-out;
}

.list_selector_block.selected {
  border-color: transparent;
}
</style>
